import React, { useEffect } from "react";
// import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import authActions from "../../redux/auth/actions";
import { useNavigate } from "react-router-dom";
import { Box, Card, CardContent, Grid,Typography } from "@mui/material";
import { cssProperties } from "../../utils/commonCssProperties";
import Layout from "../../layouts/layout";
import Sidebar from "../../layouts/sidebar";
import Header from "../../layouts/header";
import PageHeading from "../../layouts/pageHeading";

export default function RoleSelection() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);

  useEffect(() => {
    if (
      backofficeTokenDetails &&
      backofficeTokenDetails?.role?.role?.length === 1
    ) {
      dispatch({
        type: authActions.ROLE_TOKEN_GENERATION,
          payload: {
          role: backofficeTokenDetails?.role?.role[0],
          navigate: navigate,
        },
      });
    }
    //eslint-disable-next-line
  }, [backofficeTokenDetails]);

  const handleRoleSelection = (role) => {
    dispatch({
      type: authActions.ROLE_TOKEN_GENERATION,
      payload: { role: role, navigate: navigate },
    });
  };

  return (
    <>
      <Sidebar />
      <Header />
      <Layout>
      <PageHeading title={`Welcome ${backofficeTokenDetails?.name}`} />
      {backofficeTokenDetails?.role?.role?.length > 1 && (
  <Grid container spacing={3} sx={{ marginTop: '12px', justifyContent: 'center' }}>
    {backofficeTokenDetails?.role?.role?.map((val, i) => (
      <Grid
        item
        xs={12}
        sm={6}
        lg={4}
        key={i}
        display="flex"
        justifyContent="center"
        onClick={() => handleRoleSelection(val)}
      >
        <Card
          sx={{
            width: '100%',
            height: '227px',
            borderRadius: "8px",
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: "none"
          }}
        >
          <Box
            sx={{
              backgroundColor: cssProperties?.backgroundcolor?.secondary,
              color: cssProperties?.color?.textsecondary,
              border: `1px solid ${cssProperties?.bordercolor?.primary}`,
              borderRadius: '50%',
              width: '62px',
              height: '62px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '12px'
            }}
          >
            {val.icon || <Typography>{val[0]?.toUpperCase()}</Typography>}
          </Box>
          <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
            <Typography
              variant="h6"
              component="div"
              sx={{
                fontSize: 16,
                fontWeight: 700,
                color: cssProperties?.fontcolor?.tableblack,
                textAlign: 'center'
              }}
            >
              {val}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    ))}
  </Grid>
)}

      </Layout>
    </>
  );
}
